<template>
  <div class="register" v-loading="loading">
    <div class="register-title">わんにゃんメイト申込フォーム</div>

    <!-- 申込ページ -->
    <div v-if ="confirmMode === 0">
      <el-form ref="registerForm" :model="form" class="app-form" :rules="rules">
        <div class="login-docs">
          「<a href = "/terms.html" target="_blank">利用規約</a>」
          「<a href = "/privacy.html" target="_blank">個人情報保護方針について</a>」
          <span>をご確認の上お申し込みください。</span>
        </div>
        <br>
        <h1>物件（マンション/アパート）情報</h1>
        <el-form-item label="物件名称" prop="manshonName">
          <el-input v-model="form.manshonName" autocomplete="off" maxlength="64" placeholder="64桁以内"></el-input>
        </el-form-item>
        <el-form-item label="郵便番号" prop="postalCode">
          <el-input v-model="form.postalCode" maxlength="7" placeholder="半角数字7桁「ハイフン(-)なし」" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="住所区分" prop="addressKind">
          <el-input v-model="form.addressKind" maxlength="256" placeholder="256桁以内"></el-input>
        </el-form-item>
        <el-form-item label="住所その他" prop="addressOther">
          <el-input v-model="form.addressOther" maxlength="256" placeholder="256桁以内"></el-input>
        </el-form-item>
        <el-form-item label="総戸数" prop="unitCount">
          <el-input v-model="form.unitCount" maxlength="9" ></el-input>
        </el-form-item>
        <table width="100%" class="commonTable">
          <tr>
            <th>部屋番号一覧</th>
          </tr>
          <tr>
            <td>
              すべての部屋番号がわかる一覧表をアップロードしてください。<br>
              <input type="file" ref="roomListPdf" @change="onFileChange($event,'roomListPdf')" />
            </td>
          </tr>
        </table>
        <br>
        <table width="100%" class="commonTable">
          <tr>
            <th>マンションロゴ画像</th>
          </tr>
          <tr v-if="logoImgUrl">
            <td>
              <img :src="logoImgUrl" style="width: 100%;height: 200px;object-fit: contain;"/>
            </td>
          </tr>
          <tr>
            <td>
              物件を特定するためのロゴマークもしくは外観写真をアップロードしてください。<br>
              <input type="file" ref="logoImg" accept="image/jpeg,image/png,image/webp" @change="onFileChange($event,'logoImg')" />
            </td>
          </tr>
          <tr>
            <td>
              <el-button native-type="button" type="primary" plain @click="photoPreview($refs.logoImg, 'logoImgUrl');">写真プレビュー</el-button>
            </td>
          </tr>
        </table>
        <br>
        <h1>管理責任者</h1>
        <el-form-item label="漢字氏名" prop="responsibleKanji">
          <el-input v-model="form.responsibleKanji" maxlength="64" placeholder="64桁以内" ></el-input>
        </el-form-item>
        <el-form-item label="かな氏名" prop="responsibleKana">
          <el-input v-model="form.responsibleKana" maxlength="64" placeholder="64桁以内" ></el-input>
        </el-form-item>
        <el-form-item label="管理責任者メールアドレス" prop="email">
          <el-input v-model="form.email" autocomplete="off" maxlength="64" placeholder="xxx@xxx.xxx"></el-input>
        </el-form-item>
        <el-form-item label="管理責任者電話番号" prop="tel">
          <el-input v-model="form.tel" maxlength="11" placeholder="半角数字（ハイフンなし）"></el-input>
        </el-form-item>
        <el-form-item label="役割" prop="role">
          <el-select v-model="form.role" placeholder="選択してください" clearable>
            <el-option label="管理者" value="manager"></el-option>
            <el-option label="理事長" value="chair"></el-option>
            <el-option label="管理会社" value="company"></el-option>
          </el-select>
        </el-form-item>
        <h1>支払方法</h1>
        <el-form-item label="料金プラン" prop="pricingPlan">
          <!-- ★追加：料金表リンク -->
          <div style="margin-bottom: 6px;">
            <a href="/ServiceFee.html" target="_blank" style="font-size:13px; color:#409EFF;">
              📄 詳しくはこちら
            </a>
          </div>
          <el-select v-model="form.pricingPlan" placeholder="選択してください">
            <el-option label="基本プラン（年払い）" value="基本プラン（年払い）"></el-option>
            <el-option label="毎月プラン（月払い）" value="毎月プラン（月払い）"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="銀行名" prop="bankName">
          <el-input v-model="form.bankName" maxlength="64" placeholder="64桁以内"></el-input>
        </el-form-item>
        <el-form-item label="支店名" prop="branchName">
          <el-input v-model="form.branchName" maxlength="64" placeholder="64桁以内"></el-input>
        </el-form-item>
        <el-form-item label="口座区分" prop="accountType">
          <el-select v-model="form.accountType" placeholder="選択してください">
            <el-option label="普通" value="ordinary"></el-option>
            <el-option label="当座" value="current"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="口座番号" prop="accountNumber">
          <el-input v-model="form.accountNumber" maxlength="8"></el-input>
        </el-form-item>
        <table width="100%" class="commonTable">
          <tr>
            <th>銀行口座振替PDF</th>
          </tr>
          <tr>
            <td>
              ご指定いただいた金融機関へ提出が必要になりますので、<br>
              ダウンロード後必要事項記入・押印をお願いします。<br>
              弊社への提出方法は、申込完了後担当者よりご連絡いたします。</br><br>
              <el-button native-type="button" type="primary" plain @click="downloadPdf();">ダウンロード</el-button>
            </td>
          </tr>
        </table>
        <br>
        <el-form-item>
          <table width="100%">
            <tr>
              <td width="25%"></td>
              <td width="50%"></td>
              <td width="25%">
                <!-- 「次へ」クリックでは送信せず、確認画面へ -->
                <el-button type="warning" @click="goConfirm">
                  次へ
                </el-button>
              </td>
            </tr>
          </table>
        </el-form-item>
      </el-form>
    </div>

    <!-- 確認ページ -->
    <div v-else-if="confirmMode === 1">
      <table width="100%" class="commonTable">
        <tr>
          <th>申込内容の確認</th>
        </tr>
        <tr>
          <td style="text-align:left;">
            <div class="confirm-message">
              以下の内容にお間違いがないかご確認のうえ、お申し込みください。
            </div>
            <table class="confirmTable" width="100%">
              <tr><th width="35%">項目</th><th>内容</th></tr>
              <tr><td>物件名称</td><td>{{ form.manshonName }}</td></tr>
              <tr><td>郵便番号</td><td>{{ form.postalCode }}</td></tr>
              <tr><td>住所区分</td><td>{{ form.addressKind }}</td></tr>
              <tr><td>住所その他</td><td>{{ form.addressOther }}</td></tr>
              <tr><td>総戸数</td><td>{{ form.unitCount }}</td></tr>
              <tr><td>部屋番号一覧ファイル</td><td>{{ fileName(form.roomListPdf) }}</td></tr>
              <tr><td>マンションロゴ画像</td><td>{{ fileName(form.logoImg) }}</td></tr>
              <tr><td>管理責任者氏名（漢字）</td><td>{{ form.responsibleKanji }}</td></tr>
              <tr><td>管理責任者氏名（かな）</td><td>{{ form.responsibleKana }}</td></tr>
              <tr><td>メールアドレス</td><td>{{ form.email }}</td></tr>
              <tr><td>電話番号</td><td>{{ form.tel }}</td></tr>
              <tr><td>役割</td><td>{{ roleLabel }}</td></tr>
              <tr><td>料金プラン</td><td>{{ form.pricingPlan }}</td></tr>
              <tr><td>銀行名</td><td>{{ form.bankName }}</td></tr>
              <tr><td>支店名</td><td>{{ form.branchName }}</td></tr>
              <tr><td>口座区分</td><td>{{ form.accountType === 'ordinary' ? '普通' : (form.accountType === 'current' ? '当座' : '') }}</td></tr>
              <tr><td>口座番号</td><td>{{ form.accountNumber }}</td></tr>
            </table>
            <div class="confirm-actions">
              <el-button type="warning" @click="backToEdit">修正</el-button>
              <el-button type="primary" :loading="submitting" @click="submitFinal">申込</el-button>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <!-- 送信完了ページ -->
    <div v-else-if="confirmMode === 2">
      <div class="app-form resultMsg">
        {{ resultMsg }}
      </div>
    </div>

  </div>
</template>

<script>
import request from '@/utils/request';
import { Message } from 'element-ui';
import { validateFile } from '@/utils/tools';
import imageCompression from 'browser-image-compression';

export default {
  name: 'ManShonRegist',
  data() {
    return {
      loading: false,
      submitting: false,
      confirmMode: 0,  // 0: 申込画面、1: 確認画面、2: 送信完了画面
      logoPreview: '',
      logoImgUrl: '',
      resultMsg: '',
      form: {
        manshonName: '',
        postalCode: '',
        addressKind: '',
        addressOther: '',
        unitCount: '',
        roomListPdf: null,
        logoImg: null,
        responsibleKanji: '',
        responsibleKana: '',
        email: '',
        tel: '',
        role: '',
        pricingPlan: '',
        bankName: '',
        branchName: '',
        accountType: '',
        accountNumber: '',
      },
      rules: {
        manshonName: [{ required: true, message: '必須です。', trigger: 'blur' }],
        postalCode: [
          { required: true, message: '必須です。', trigger: 'blur' },
          { pattern: /^[0-9]{7}$/, message: '7桁で入力してください（ハイフンなし）。', trigger: 'blur' }
        ],
        addressKind: [{ required: true, message: '必須です。', trigger: 'blur' }],
        addressOther: [{ required: true, message: '必須です。', trigger: 'blur' }],
        unitCount: [
          { required: true, message: '必須です。', trigger: 'blur' },
          { pattern: /^[0-9]+$/, message: '半角数字で入力してください。', trigger: 'blur' }
        ],
        roomListPdf: [{ required: true, message: '部屋番号一覧ファイルをアップロードしてください。', trigger: 'change' }],
        responsibleKanji: [{ required: true, message: '必須です。', trigger: 'blur' }],
        responsibleKana: [{ required: true, message: '必須です。', trigger: 'blur' }],
        email: [
          { required: true, message: '必須です。', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: '有効なメールアドレスを入力してください。', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '必須です。', trigger: 'blur' },
          { pattern: /^[0-9]{1,11}$/, message: '半角数字（ハイフンなし）で入力してください。', trigger: 'blur' }
        ],
        role: [{ required: true, message: '必須です。', trigger: 'change' }],
        pricingPlan: [{ required: true, message: '必須です。', trigger: 'change' }],
        bankName: [{ required: true, message: '必須です。', trigger: 'blur' }],
        branchName: [{ required: true, message: '必須です。', trigger: 'blur' }],
        accountType: [{ required: true, message: '必須です。', trigger: 'change' }],
        accountNumber: [{ required: true, message: '必須です。', trigger: 'blur' }],
      }
    };
  },

  // // ★ 追加：进入页面时直接清空 App.vue 顶部的公寓名
  // created() {
  //   let p = this.$parent;
  //   while (p) {
  //     if (p.manshonName !== undefined) {
  //       p.manshonName = '';
  //       break;
  //     }
  //     p = p.$parent;
  //   }
  // },

  computed: {
    roleLabel() {
      if (this.form.role === 'manager') return '管理者';
      if (this.form.role === 'chair') return '理事長';
      if (this.form.role === 'company') return '管理会社';
      return '';
    }
  },

  // ★追加：郵便番号が7桁になったら住所を自動入力
  watch: {
    'form.postalCode'(val) {
      if (!/^[0-9]{7}$/.test(val)) return;
      fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${val}`)
        .then(r => r.json())
        .then(data => {
          if (data.results) {
            const r = data.results[0];
            this.form.addressKind = (r.address1 || '') + (r.address2 || '') + (r.address3 || '');
          }
        })
        .catch(() => {});
    }
  },

  methods: {
    fileName(file) {
      return file ? (file.name || '') : '';
    },

    photoPreview(fileInputRef, imgUrlField) {
      const imageFile = fileInputRef.files[0];
      // ファイルチェック（未選択、拡張子、サイズ）
      const msg = validateFile(imageFile, {
        allowedTypes: ['image/jpeg', 'image/png', 'image/webp'],
        maxSizeMB: 20,
        msg: 'マンションロゴ画像'
      });
      if (msg) {
        this.$message.error(msg);
        return;
      }
      // プレビュー画像生成
      const reader = new FileReader();
      reader.onload = (e) => {
        this[imgUrlField] = e.target.result;
      };
      reader.readAsDataURL(imageFile);
    },

    onFileChange(e, key) {
      const f = e.target.files[0];
      this.$set(this.form, key, f || null);
    },

    // 修正ボタン押下
    backToEdit() {
      this.confirmMode = 0;
      this.form.roomListPdf = null;
      this.form.logoImg = null;
      this.$nextTick(() => {
        if (this.$refs.roomListPdf) this.$refs.roomListPdf.value = '';
        if (this.$refs.logoImg) this.$refs.logoImg.value = '';
        this.logoImgUrl = '';
      });
    },

    // 申込 → 確認へ（まだ送信しない）
    goConfirm() {
      this.$refs.registerForm.validate((valid) => {
        if (!valid) return;

        // ここで「再選択必須」を確実にチェック（input をクリアした場合は null になる）
        const roomListPdf = this.form.roomListPdf;
        const roomListPdfMsg = validateFile(roomListPdf, { allowedTypes: null, maxSizeMB: 20, msg: '部屋番号一覧' });
        if (roomListPdfMsg) { Message.error(roomListPdfMsg); return; }

        const logoImg = this.form.logoImg;
        const logoImgMsg = validateFile(logoImg, { allowedTypes: ['image/jpeg','image/png','image/webp'], maxSizeMB: 20, msg: 'マンションロゴ画像' });
        if (logoImgMsg) { Message.error(logoImgMsg); return; }

        this.confirmMode = 1; 
      });
    },

    // 送信ボタン押下
    async submitFinal() {
      this.submitting = true;
      try {
        const formData = new FormData();

        // 通常項目
        Object.entries(this.form).forEach(([k, v]) => {
          if (k === 'roomListPdf' || k === 'logoImg') return;
          formData.append(k, v == null ? '' : v);
        });

        // 部屋番号一覧：任意形式、圧縮なし
        const roomListPdf = this.form.roomListPdf;
        formData.set('roomListPdfFile', roomListPdf, roomListPdf.name);

        // ロゴ画像：圧縮
        const logoImg = this.form.logoImg;
        const compressed = await imageCompression(logoImg, { maxSizeMB: 1, maxWidthOrHeight: 1024, useWebWorker: true });
        formData.set('logoImgFile', compressed, logoImg.name);

        // フォームデータ送信
        this.loading = true;
        const res = await request('manshonRegist', formData);
        // Message.success(res.msg);

        // 送信後：画面はメッセージのみ表示
        this.resultMsg = res.msg;
        this.confirmMode = 2;

      } finally {
        this.loading = false;
        this.submitting = false;
      }
    },

    downloadPdf() {
      // iOSのSafariのブロックを防ぐために事前に新規タブを開く
      const newWindow = window.open('about:blank');
      request('downloadDirectDebitPdf').then((res) => {
        newWindow.location = res.generatePresignedUrl;
      });
    }

  }
};
</script>

<style lang="less">
  .commonTable {
    width: 100%;
    text-align: center;
    border-collapse: collapse;
    border-spacing: 0;
    border: solid 2px #778ca3;
  }
  .commonTable th {
    padding: 10px;
    background: #e9faf9;
    border: solid 1px #778ca3;
    border-bottom: solid 2px #778ca3;
  }
  .commonTable td {
    padding: 10px;
    border-left: solid 1px #778ca3;
    text-align: left;
    vertical-align: top;
  }
  .commonTable tr {
    border-top: dashed 1px #778ca3;
  }
  h1 {
    padding: 0.25em 0.5em;
    color: #494949;
    background: transparent;
    border-left: solid 5px #7db4e6;
  }
  .register {
    margin: 10px auto;
    max-width: 900px;
    .register-title {
      text-align: center;
      font-size: 28px;
      font-weight: bold;
      margin: 16px 0 24px 0;
    }
  }
  table { width:100%; }
  input[type="file"] { margin-top:6px; }
  .logo-preview { max-width:100%; max-height:200px; object-fit:contain; display:block; }
  html, body { overflow-x: hidden; width:100%; }
  @media (max-width: 767px) {
    .register { padding: 0 12px; }
    .register-title { font-size:22px; }
    .el-form-item { display:block; }
  }

  /* 確認画面用（申込画面の見た目は一切変更しない） */
  .confirm-message {
    margin-bottom: 12px;
    font-size: 14px;
    color: #333;
  }
  .confirmTable {
    width: 100%;
    border-collapse: collapse;
    border: solid 1px #778ca3;
  }
  .confirmTable th,
  .confirmTable td {
    border: solid 1px #778ca3;
    padding: 8px 10px;
    text-align: left;
    vertical-align: top;
    background: #fff;
  }
  .confirmTable th {
    background: #f5fbff;
  }
  .confirm-actions {
    margin-top: 14px;
    text-align: right;
  }
  /* 確認画面用（申込画面の見た目は一切変更しない） */
  .confirm-actions {
    margin-top: 14px;
    text-align: right;
  }
  .confirm-actions .el-button {
    min-width: 160px; 
  }

  .resultMsg {
    white-space: pre-line;
    overflow-wrap: anywhere;
    word-break: break-word;
    max-width: 100%;
  }

  .login-docs {
    text-align: center;
    font-size: 16px;
    margin-bottom: 24px;
  }

</style>
